import { setURL } from '@/api/apiUtil'

export default {
  /**
   * 登入
   */
  postLogin: {
    url: setURL('/AccountAPI/api/User/login', {}, true),
    method: 'post'
  },
  getUserInfo: {
    url: setURL('/AccountAPI/api/User/info', {}, true),
    method: 'get'
  },
  logout: {
    url: setURL('/kbro_api/api/v1/User/logout/web', {}, true),
    method: 'post'
  },
  allUserRoles: {
    url: setURL('/AccountAPI/api/User/roles', {}, true),
    method: 'get'
  }
}
